import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import MetaTags from 'react-meta-tags';
import ArtistService from '../../../services/artistService.js';
import * as artistActions from '../../../actions/artistActions';
import * as genreActions from '../../../actions/genreActions';
import * as instrumentActions from '../../../actions/instrumentActions';
import roleTypes from '../../../constants/roleTypes';
import Browse from './Browse';
import Search from './Search';
import Results from './Results';
import PageLoading from '../../common/PageLoading';

class ProfileBrowsePage extends React.Component {
    constructor(props, context) {
        super(props, context);
        const route = props.match.path.split('/')[1];
        const roleType = roleTypes.find(r => r.route == route);
        this.roleType = roleType;        
        this.getRoleTypeText = this.getRoleTypeText.bind(this);
        this.getGenre = this.getGenre.bind(this);
        this.getAssociation = this.getAssociation.bind(this);
        this.getHeader = this.getHeader.bind(this);
        this.getTitle = this.getTitle.bind(this);
        this.getMetaDescription = this.getMetaDescription.bind(this);
        this.setSelectedTab = this.setSelectedTab.bind(this);
        this.props.actions.setBrowseRoleType(this.roleType);        
    }

    componentWillMount() {        
        
    }

    componentDidMount() {       
        $('#btnPop').on('click', function (e) {
            e.preventDefault();
            $('#popover').toggleClass('showpop');
            e.stopPropagation();
        });
        $('body').on('click', this.removePopOver);
    }

    componentWillUnmount() {
        $('body').off('click', this.removePopOver);
    }

    removePopOver(e) {
        if ($('#popover').hasClass('showpop')) {
            $('#popover').removeClass('showpop');
        }
    }

    getGenre() {
        return this.props.browse.searchCriteria.selectedGenres.length == 1 ? this.props.browse.searchCriteria.selectedGenres[0] + ' ' : '';
    }

    getAssociation() {
        return this.props.browse.searchCriteria.selectedAssociations.length == 1 ? ` like ${this.props.browse.searchCriteria.selectedAssociations[0].label}` : '';
    }

    getRoleTypeText() {
        if(this.roleType.type == 'Artist') {
            return 'Artists/Bands';
        }
        else if(this.roleType.type == 'Fan') {
            return 'Music Fans';
        }
        else {
            return this.roleType.friendlyName + 's';
        } 
    }

    getHeader() {
        return this.getGenre() + this.getRoleTypeText() + this.getAssociation();
    }

    getTitle() {
        const header = this.getHeader();
        //if we've added genres or influences to the header, then reflect it in the title
        if(this.roleType.type == 'Producer') {            
            return header == 'Producers' ? 'Find a music producer - LoudUp' : `Find ${header} - LoudUp`;
        }
        else if(this.roleType.type == 'RecordingStudio') {
            return 'Find a recording studio - LoudUp';
        }
        else if(this.roleType.type == 'Musician') {
            return header == 'Musicians' ? 'Find a musician - LoudUp' : `Find ${header} - LoudUp`;
        }
        else if(this.roleType.type == 'Artist') {
            return `Browse Independent ${header} - LoudUp`;
        }
        else if(this.roleType.type == 'Fan') {
            return header == 'Fans' ? 'Browse Music Fans - LoudUp' : `Browse ${header} - LoudUp`;
        }
        else {
            return `${this.roleType.friendlyName}s - LoudUp`;
        }
    }

    getMetaDescription() {
        return `Browse ${this.roleType.friendlyName.toLowerCase()}s on LoudUp, filter by ${ArtistService.getRoleFilterOptions(this.roleType.type)}`;
    }
    
    setSelectedTab(event) {
        event.preventDefault();
        this.props.actions.setBrowseTab(event.target.name);
        this.props.actions.clearProfiles();
    }

    render() {
        //const artist = this.props.artist;
        //const actions = this.props.actions;
        return (
            <div className="main">
                <MetaTags>
                    <title>{this.getTitle()}</title>            
                    <meta id="description" name="description" content={this.getMetaDescription()} />                
                </MetaTags>
                <div className="container">
                    <div className="block-inner">   
                    {
                        this.roleType.type == 'Artist' || this.roleType.type == 'Fan' ?
                            <div className="popbox">
                                <div id="popover" className="popover">
                                    <a id="btnPop" href="#" className="btn-pop transition">
                                        <div className="dot" />
                                        <svg className="icon icn-music-alert transition">
                                            <use xlinkHref="#icn-music-alert" />
                                        </svg>
                                    </a>
                                    <div className="inner transition2">
                                    {
                                        this.roleType.type == 'Fan' ?
                                            <p>Find fans who share your music taste. You will benefit from being able to share new music you discover and might even make a friend or gig buddy. We're not promising you'll meet your soulmate...there are other sites for that...</p>
                                            : 
                                            <p>Your road to music discovery starts here. Whether you're looking to find something obscure or discover the next big thing, this is the place to be! Take your time and explore, your ears will thank you for it!</p>
                                    }                                
                                    </div>
                                </div>
                            </div> : null
                    }
                    <h1 id="roleBrowseTitle" className="section-alt">{`${this.getHeader()}`}</h1>
                    <ul className="nav nav-tabs tabs-lined" role="tablist">
                        <li className={this.props.browse.selectedTab == 'browse' ? 'active' : ''}>
                            <a id="lnkBrowse" href="#" name="browse" className="transition" onClick={this.setSelectedTab}>BROWSE</a>
                        </li>
                        <li className={this.props.browse.selectedTab == 'search' ? 'active' : ''}>
                            <a id="lnkSearch" href="#" name="search" className="transition" onClick={this.setSelectedTab}>SEARCH</a>
                        </li>
                    </ul>
                        <div id="browse" className="tab-content" style={{minHeight:'200px'}}>
                            <div className="tab-pane active">
                                <div id="browseSearchContent"className="search-with-filters">
                                    { this.props.browse.selectedTab == 'browse' ? 
                                        <Browse roleType={this.roleType} actions={this.props.actions} searchCriteria={this.props.browse.searchCriteria} searchError={this.props.browse.browseError} genres={this.props.genres} instruments={this.props.instruments} genreParam={this.props.match.params.genre} associationParam={this.props.match.params.association} user={this.props.user} location={this.props.location} />
                                        : <Search roleType={this.roleType} actions={this.props.actions} keyword={this.props.browse.keyword} searchError={this.props.browse.searchError} />
                                    }
                                </div>
            
                                <div id="searchresults" style={{paddingTop: 0}}>
                                    <Results roleType={this.roleType} results={this.props.browse.results} actions={this.props.actions} loadingStatus={this.props.browse.loadingStatus} location={this.props.location} />
                                </div>
                            </div>
                        </div>
                        {/*<div className="extcontent" style="text-align: center;">
                        @if (LoudUp.Web.WebUtility.ShowAdsense(Request))
                        {
                            <script async src="//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>
                            <!-- Footer Ad -->
                            <ins className="adsbygoogle"
                                    style="display:block"
                                    data-ad-client="ca-pub-5843337326619722"
                                    data-ad-slot="3370753097"
                                    data-ad-format="auto"></ins>
                            <script>
                                (adsbygoogle = window.adsbygoogle || []).push({});
                            </script>
                        }
                        else
                        {
                            Html.RenderAction("GetAdUnit", "Ad", new { adType = LoudUp.Web.Models.AdModel.enmAdType.Footer, id = "contentFooter" });
                        }
                        </div>*/}
                    </div>
                </div>
            </div>
        );
    }
}

ProfileBrowsePage.propTypes = {
    browse: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    genres: PropTypes.array.isRequired,
    instruments: PropTypes.array.isRequired,
    match: PropTypes.object.isRequired,
    user: PropTypes.object,
    location: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    return { browse: state.artists.browse, genres: state.genres, instruments: state.instruments, user: state.account.user };
}

function mapDispatchToProps(dispatch) {
    return {
        //artist actions will now be available under this.props.actions
        actions: bindActionCreators(Object.assign({}, artistActions, genreActions, instrumentActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileBrowsePage);
